import { render, staticRenderFns } from "./DisbursementSummary.vue?vue&type=template&id=981ee2b6"
import script from "./DisbursementSummary.vue?vue&type=script&lang=js"
export * from "./DisbursementSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports